import { buildGlobalAction, buildInlineComputedView } from "./../../builder.js";
class ClickhouseMessagesNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the getAnalytics global action. */
    this.getAnalytics = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getAnalytics",
      operationName: "getAnalytics",
      operationReturnType: "ClickhouseMessagesGetAnalytics",
      namespace: ["clickhouse", "messages"],
      variables: {
        period: { required: false, type: "String" },
        between: {
          required: false,
          type: "ClickhouseMessagesGetAnalyticsBetweenInput"
        }
      }
    });
    /** Executes the insertMessages global action. */
    this.insertMessages = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "insertMessages",
      operationName: "insertMessages",
      operationReturnType: "ClickhouseMessagesInsertMessages",
      namespace: ["clickhouse", "messages"],
      variables: {
        messages: { required: false, type: "String" },
        source: { required: false, type: "String" },
        retry: { required: false, type: "Boolean" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: ["clickhouse", "messages"],
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  ClickhouseMessagesNamespace
};
//# sourceMappingURL=messages.js.map
